module.exports = __webpack_public_path__ + "static/media/globe-asia.6e2ee547.svg";